import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { AppComponent } from "./app.component";
import { HomeComponent } from "./home/home.component";
import { RouterModule, Routes } from "@angular/router";
import { HttpClientModule } from "@angular/common/http";
import { HttpModule } from "@angular/http";
import { PharmacyComponent } from "./pharmacy/pharmacy.component";
import { MycardsComponent } from "./mycards/mycards.component";
import { AgmCoreModule } from "@agm/core";
import { GetcardComponent } from './getcard/getcard.component';
import { SearchComponent } from './search/search.component';
import { SearchNavComponent } from './search-nav/search.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';

import { AboutUsComponent } from './about-us/about-us.component';
import { PricingComponent } from './pricing/pricing.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { AccordianComponent } from './accordian/accordian.component';
import { DownloadComponent } from './download/download.component';
import { HowWorksComponent } from './how-works/how-works.component';
import { HelpComponent } from './help/help.component';
import { TermsofuseComponent } from './termsofuse/termsofuse.component';
import { DomainAffiliateComponent } from './domain-affiliate/domain-affiliate.component';
import { CardComponent } from './card/card.component';
import { TermsComponent } from './terms/terms.component';
import {ComplianceesourcesComponent} from './compliance-resources/compliance.component';
import {LittleAngelHandsComponent} from './little-angel-hands/little-angel-hands.component';
import {PetPrescriptionsComponent} from './pet-prescriptions/pet-prescriptions.component';
import {OrdinalDatePipe} from '../ordinal-date.pipe';
// import { NgxSlickCarouselModule } from 'ngx-slick-carousel';


// Google ReCaptcha START
import {
  RECAPTCHA_SETTINGS,
  RecaptchaSettings,
  RecaptchaLoaderService,
  RecaptchaModule,
} from 'ng-recaptcha';

import { ComplianceComponent } from './compliance/compliance.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ProgramDescriptionComponent } from './program-description/program-description.component';
import { DrugsComponent } from './drugs/drugs.component';
import { DownloadAppComponent } from './download-app/download-app.component';
import { TimifitComponent } from './timifit/timifit.component';
import { LoaderPopupComponent } from './shared/loader-popup/loader-popup.component';
import { ErrorPopupComponent } from './shared/error-popup/error-popup.component';
import { UnderinsuredComponent } from './underinsured/underinsured.component';
import { SafarilinkComponent } from './safarilink/safarilink.component';
import { ConsumersignupComponent } from './consumersignup/consumersignup.component';
import { HomeAccordianComponent } from './home-accordian/home-accordian.component';
import { PetsAccordianComponent } from './pets-accordian/pets-accordian.component';
// import { PetPrescriptionsComponent } from './pet-prescriptions/pet-prescriptions.component';
// import { LittleAngelHandsComponent } from './little-angel-hands/little-angel-hands.component';

const globalSettings: RecaptchaSettings = { siteKey: '6LcY2gUaAAAAAB1rIXaSuXip3Bl0HOdolscjgsmU' };

// Google ReCaptcha END

const appRoutes: Routes = [
  { path: "", component: HomeComponent, data: {
    title: 'NuLifeSpan Rx | Save on Prescription Medications with our Discount Card',
    description: 'Our discount card helps make prescription medications more affordable for everyone. No enrollment fees and no restrictions on usage. Save on your next prescription at participating pharmacies nationwide.'
  }},
  { path: "Home", component: HomeComponent, data: {
    title: 'NuLifeSpan Rx | Save on Prescription Medications with our Discount Card',
    description: 'Our discount card helps make prescription medications more affordable for everyone. No enrollment fees and no restrictions on usage. Save on your next prescription at participating pharmacies nationwide.'
  }},
  { path: "Pharmacy", component: PharmacyComponent},
  { path: "MyCards", component: MycardsComponent, data: {
    title: 'NuLifeSpan Rx | View Your Saved Prescription Discount Cards',
    description: 'Our online platform makes it easy to view and access your saved prescription discount cards in one convenient location. No more searching through wallets and drawers - all of your cards are just a click away.'
  }},
  { path: 'aboutUs', component: AboutUsComponent},
  { path: 'pricing', component: PricingComponent, data: {
    title: 'Compare Prices on Prescription Medications',
    description: 'Our search tool makes it easy to compare prices on prescription medications at pharmacies in your area. Simply enter your zip code and the name of the drug you need to find the best deals.'
  }},
  { path: 'contact', component: ContactUsComponent, data: {
    title: 'NuLifeSpan Rx | Contact Us for More Information on Prescription Discounts',
    description: 'Have questions about our prescription discount program? Need assistance finding the lowest prices on medications? Contact us and one of our friendly representatives will be happy to help.'
  }},
  { path: 'little-angel-hands', component: LittleAngelHandsComponent, data: {
    title: 'NuLifeSpan Rx | Little Angle Hands Us for More Information on Prescription Discounts',
    description: 'Have questions about our prescription discount program? Need assistance finding the lowest prices on medications? Contact us and one of our friendly representatives will be happy to help.'
  }},
  { path: 'pet-prescriptions', component: PetPrescriptionsComponent, data: {
    title: 'NuLifeSpan Rx | Pet Prescriptions Component for More Information on Prescription Discounts',
    description: 'Have questions about our prescription discount program? Need assistance finding the lowest prices on medications? Contact us and one of our friendly representatives will be happy to help.'
  }},
  { path: 'Underinsured', component: UnderinsuredComponent, data: {
    title: 'NuLifeSpan Rx | Underinsured Us for More Information on Prescription Discounts',
    description: 'Have questions about our prescription discount program? Need assistance finding the lowest prices on medications? Contact us and one of our friendly representatives will be happy to help.'
  }},
  { path: 'download-mobile-app', component: DownloadComponent },
  { path: 'howItWorks', component: HowWorksComponent },
  { path: 'help', component: HelpComponent },
  { path: 'termsofuse', component: TermsofuseComponent },
  { path: 'domain-affiliate', component: DomainAffiliateComponent },
  { path: 'card/:id', component: CardComponent },
  { path: 'Card/:id', component: CardComponent },
  { path: 'terms', component: TermsComponent },
  // { path: 'compliance', component: ComplianceComponent },
  { path: 'compliance', component: ComplianceesourcesComponent },
  { path: 'privacy', component: PrivacyComponent },  
  { path: 'program', component: ProgramDescriptionComponent },  
  { path: 'drugs', component: DrugsComponent, data: {
    title: 'NuLifeSpan Rx | Find out which drugs are covered by our discount program',
    description: 'Our discount program offers discounts on many common prescription medications. View the complete list of drugs covered by our program and start saving on your medication costs.'
  }},
  { path: 'download-app', component: DownloadAppComponent, data: {
    title: 'NuLifeSpan Rx | Get the Best Deals on Prescription Medications with our App',
    description: 'Our mobile app makes it easy to search for the lowest prices on prescription medications. Simply enter your zip code and the name of the drug you need, and our app will show you the cheapest prices at pharmacies near you.'
  }},
  /*{ path: 'fit-economy', component: TimifitComponent, data: {
    title: 'NuLifeSpan Rx | Get Fit and Earn Crypto with Our Move to Earn Program',
    description: 'Our Move to Earn program rewards you for being active and reaching your fitness goals. Join the NuLifeSpan Rx network on Timifit to start earning crypto for your workouts and daily activity.'
  }},*/
  { path: 'safaridefault', component: SafarilinkComponent, data: {
    title: 'NuLifeSpan Rx | Safari link'
  }},
  { path: 'timifit', redirectTo: '/fit-economy', pathMatch: 'full' },
  { path: 'fit-economy', redirectTo: '/Home', pathMatch: 'full' },
  { path: "**", component: HomeComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutUsComponent,
    PricingComponent,
    ContactUsComponent,
    HeaderComponent,
    FooterComponent,
    PharmacyComponent,
    MycardsComponent,
    GetcardComponent,
    SearchComponent,
    SearchNavComponent,
    AccordianComponent,
    DownloadComponent,
    HowWorksComponent,
    HelpComponent,
    TermsofuseComponent,
    DomainAffiliateComponent,
    CardComponent,
    TermsComponent,
    ComplianceComponent,
    ComplianceesourcesComponent,
    PrivacyComponent,
    ProgramDescriptionComponent,
    DrugsComponent,
    OrdinalDatePipe,
    DownloadAppComponent,
    TimifitComponent,
    LoaderPopupComponent,
    ErrorPopupComponent,
    LittleAngelHandsComponent,
    PetPrescriptionsComponent,
    UnderinsuredComponent,
    SafarilinkComponent,
    ConsumersignupComponent,
    HomeAccordianComponent,
    PetsAccordianComponent
  ],
  imports: [
    RecaptchaModule.forRoot(),
    RouterModule.forRoot(
      appRoutes

      // { enableTracing: true } // <-- debugging purposes only
    ),
    BrowserModule,
    HttpClientModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyAuNL17CjdSdiDc3fQ46T6Sy2oB2UPuLB0"
    }),
    SlickCarouselModule,
    // NgxSlickCarouselModule
  ],
  providers: [{
    provide: RECAPTCHA_SETTINGS,
    useValue: globalSettings,
  }],
  
  bootstrap: [AppComponent]
})
export class AppModule { }